var React = require('react');

function SocialIconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"nonzero","d":"M224.937 2.062L186.321 2c-43.385 0-71.422 28.689-71.422 73.092v33.7H76.072c-3.355 0-6.072 2.713-6.072 6.06v48.828c0 3.346 2.72 6.055 6.072 6.055H114.9v123.209c0 3.346 2.717 6.056 6.072 6.056h50.659c3.355 0 6.072-2.713 6.072-6.056V169.735H223.1c3.355 0 6.072-2.71 6.072-6.055l.019-48.828a6.057 6.057 0 0 0-1.778-4.283 6.081 6.081 0 0 0-4.297-1.777h-45.414V80.224c0-13.73 3.28-20.701 21.215-20.701l26.014-.01c3.352 0 6.069-2.712 6.069-6.056V8.117c0-3.34-2.714-6.049-6.063-6.055z"}));
}

SocialIconFacebookInline.defaultProps = {"viewBox":"0 0 300 300"};

module.exports = SocialIconFacebookInline;

SocialIconFacebookInline.default = SocialIconFacebookInline;
